import { Fragment } from 'react';

import {
  mailVariableChipClassName,
  mailVariableLabels,
  splitMailVariables,
} from '../lib/mailVariables';

export function MailVariableChip({ label }: { label: string }) {
  return <span className={mailVariableChipClassName}>{label}</span>;
}

type MailVariableBodyProps = {
  body: string;
  className?: string;
};

export default function MailVariableBody({ body, className }: MailVariableBodyProps) {
  return (
    <div className={className ?? 'text-body-sm break-words whitespace-pre-wrap text-main'}>
      {splitMailVariables(body).map((part, index) => {
        const label = mailVariableLabels.get(part);
        return label ? (
          <MailVariableChip key={index} label={label} />
        ) : (
          <Fragment key={index}>{part}</Fragment>
        );
      })}
    </div>
  );
}
